module.exports = __webpack_public_path__ + "lj1.png?cb3619cc3ca1628fed3dda349fb8d20f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lj1.png
// module id = 640
// module chunks = 0